






































































import Vue, { PropType } from 'vue';
import { cloneDeep } from 'lodash';
import { AxiosError } from 'axios';

import { ErrorManager } from '@/models/error';
import {
  ConfigurationItem,
  ConfigurationItemFieldError
} from '@/models/configurator/configuration';
import { QuoteProductItem, QuoteProductCategory } from '@/models/quote';

import CSIItemSearch from '@/components/csi/ItemSearch.vue';
import { mapActions } from 'vuex';
import ALDialog from '@/components/core/Dialog/ALDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default Vue.extend({
  name: 'ConfigurableItemFormDialog',

  components: { CSIItemSearch, ALDialog, ErrorAlert },

  props: {
    product: {
      type: Object as PropType<QuoteProductItem>
    },
    quoteProductCategory: Object as PropType<QuoteProductCategory>,

    configurationItems: {
      type: Array as PropType<ConfigurationItem[]>
    },
    quoteId: Number,
    quoteRevision: Number,
    snapshot: Number
  },

  data: () => ({
    loading: false,
    isFormValid: false,
    isEdit: false,
    dialog: false,
    selectedConfigurationItem: null as null | ConfigurationItem,
    configurationItem: null as null | ConfigurationItem,
    configurationItemOriginalCopy: null as null | ConfigurationItem,
    errorMessage: '',
    detailErrorMessage: '',

    fieldError: new ConfigurationItemFieldError(),
    itemRules: [(v: string) => !!v || 'Item is required']
  }),

  methods: {
    ...mapActions('configuratorConfiguration', [
      'updateConfigurationItem',
      'createConfigurationItem'
    ]),

    open(configurationItem = new ConfigurationItem(), isEdit = false) {
      this.configurationItemOriginalCopy = configurationItem;
      this.configurationItem = cloneDeep(this.configurationItemOriginalCopy);
      if (configurationItem.item) {
        this.selectedConfigurationItem = configurationItem;
      }
      this.isEdit = isEdit;
      this.clearAllErrors();
      this.dialog = true;
    },

    clearAllErrors(): void {
      this.fieldError.clearErrors();
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    close() {
      this.dialog = false;
      this.selectedConfigurationItem = null;
    },

    async saveConfigurationItem(): Promise<void> {
      this.clearAllErrors();
      this.loading = true;
      try {
        if (this.isEdit) {
          await this.updateConfigurationItem(this.configurationItem);
        } else {
          await this.createConfigurationItem(this.configurationItem);
        }

        this.loading = false;

        this.close();

        this.$emit('saved');
      } catch (err) {
        this.loading = false;
        const error = err as AxiosError;
        if (error.response) {
          // client received an error response that falls out of range 2xx
          if (
            ConfigurationItemFieldError.isConfigurationItemFieldError(
              error.response.data
            )
          ) {
            this.fieldError = new ConfigurationItemFieldError(
              error.response.data
            );
          }

          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        }

        this.errorMessage = ErrorManager.extractApiError(error);
      }
    },

    addConfigurationItem(item: ConfigurationItem) {
      // parse to configurable item
      if (item) {
        const parsedConfigItem = new ConfigurationItem();

        parsedConfigItem.item = item.item;
        parsedConfigItem.quantity = 1;
        parsedConfigItem.unit = item.unit;
        parsedConfigItem.description = item.description;
        parsedConfigItem.configuration = this.product.configuration;
        parsedConfigItem.unit_price = Number(item.price);

        parsedConfigItem.unit_discount = 0;

        parsedConfigItem.order = this.configurationItems.length + 1;
        parsedConfigItem.is_machine = item.is_machine;
        parsedConfigItem.is_obsolete = item.is_obsolete;

        this.configurationItem = parsedConfigItem;
      }
    }
  }
});
